import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class FattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/fatture/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      res.data.map((el) => {
        el.totale_fattura =  parseFloat((el.totale_fattura ).toFixed(2))
        el.pagato =  parseFloat((el.pagato).toFixed(2))
        el.saldo =  parseFloat((el.totale_fattura - el.pagato).toFixed(2))
        

        if( (el.dilazione == null)){
          el.dilazione = false
        }else{
          el.dilazione = true
        }

        if (el.contestazione === 1 || el.contestazione === '1') {
          el.contestazione = 'SI'
        } else {
          el.contestazione = 'NO'
        }
      })

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }

  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'numero',
        label: 'Numero Fattura',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        default: true,
        sortable: true,
      },
      {
        property: 'mese_fatturazione',
        label: 'Mese Fatturazione',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_emissione',
        label: 'Data Emissione',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_scadenza',
        label: 'Data Scadenza',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: "data_pagamento",
        label: "Data Pagamento",
        sortable: true,
      },
      {
        property: "invioPreavviso",
        label: "Data Invio Preavviso",
        sortable: true,
        type: {
          isDate: true
        },
      },
      {
        property: "invioStorni",
        label: "Data Invio Storno",
        sortable: true,
        type: {
          isDate: true
        },
      },
      {
        property: "invioSollecito",
        label: "Data Invio Sollecito",
        sortable: true,
        type: {
          isDate: true
        },
      },
      {
        property: "imponibile",
        label: "Imponibile",
        type: {
          isCurrency:true
        },
      },
      {
        property: "iva",
        label: "Importo IVA",
        type: {
          isCurrency:true
        },
      },
      {
        property: "totale_fattura",
        label: "Importo Fattura",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "pagato",
        label: "Importo Pagato",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "saldo",
        label: "Saldo",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "contestazione",
        label: "Contestazione",
        sortable: true,
        default: true,
      },
      {
        property: "importo_contabile",
        label: "Importo Contabile",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "cmor_tot",
        label: "Cmor",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "dep_cauzionale",
        label: "Dep.Cauzionale",
        sortable: true,
        type: {
          isCurrency:true
        },
      },
      {
        property: "pagamento",
        label: "Pagamento",
        sortable: true,
        default: true,
      },
      {
        property: "pod",
        label: "POD",
        default: true,
      },
      {
        property: "pdr",
        label: "PDR",
        default: true,
      },
      {
        property: "data_inizio_rcu",
        label: "Data Inizio Fornitura",
        default: true,
      },
      {
        property: "data_fine_rcu",
        label: "Data Fine Fornitura",
        default: true,
      },
      {
        property: "stato_fornitura",
        label: "Stato Interno Fornitura",
        default: true,
      },
      {
        property: "qta",
        label: "QTA",
        default: true,
      },
      {
        property: "piva",
        label: "Partita IVA Cliente",
      },
      {
        property: "codfis",
        label: "Codice Fiscale Cliente",
      },
      {
        property: "ragsoc",
        label: "Cliente",
        sortable: true,
        default: true
      },
      {
        property: "rappresentante",
        label: "Rappresentante",
        sortable: true,
        default: true
      },
      {
        property: "agente",
        label: "Agente",
        sortable: true,
        default: true
      },
      {
        property: "udd1",
        label: "udd",
        sortable: true,
        default: false
      },
      // {
      //   property: "mora",
      //   label: "Messa In Mora",
      //   type: {
      //     isDate: true
      //   },
      //   sortable: true,
      // },
      {
        property: "dilazione",
        label: "Dilazione",
        type: {
          isBoolean:true
        },
        default: true
      },
      {
        property: "offerta",
        label: "Offerta",
        sortable: true,
      },
      {
        property: "stato_pod",
        label: "Stato POD/PDR (RCU)",
        sortable: true,
      },
      {
        property: "stato_fornitura",
        label: "Stato Fornitura",
        sortable: true,
      },
      {
        property: "email",
        label: "Email",
      },
      {
        property: 'banca',
        label: 'Banca RID',
        sortable: true,
      },
      {
        property: 'data_invio_cliente',
        label: 'Data Invio Cliente',
        type: {
          isDate: true
        },
        sortable: true,
      },
      {
        property: 'albero_agenti',
        label: 'Albero Agenti',
        sortable: true,
        default: true
      },
    ]
  }

  async getDettaglioFattura(numero){
    let item = {}

    const url = `${this.baseUrl}/clienti/fatture/${numero}`
    try {
      let res = await this.http.get(url)
      res = res.data

      let tipo = 'POD'
      if(res.data.info.pod == null){
        tipo = 'PDR'
      }
      res.data.info.tipo = tipo

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }


  async openFatturaPdf(numero, data_emissione){
    let url;
    try {
      const dettaglio = await this.getDettaglioFattura(numero);
      if (!dettaglio.item || !dettaglio.item.numero) {
        throw new Error('Numero fattura non disponibile');
      }

      if (!data_emissione && dettaglio.item.info && dettaglio.item.info.data_emissione) {
        data_emissione = dettaglio.item.info.data_emissione;
      }

      if (!data_emissione) {
        throw new Error('Data emissione non disponibile');
      }

      let formattedDate = data_emissione;
      if (data_emissione.includes('/')) {
        const parts = data_emissione.split('/');
        if (parts.length === 3) {
          formattedDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        }
      } else if (data_emissione.includes('-')) {
        const dateParts = data_emissione.split('-');
        if (dateParts.length === 3) {
          formattedDate = `${dateParts[0]}-${dateParts[1].padStart(2, '0')}-${dateParts[2].padStart(2, '0')}`;
        }
      }

      const requestData = {
        number: dettaglio.item.numero,
        data_emissione: formattedDate
      };

      const response = await this.http.post(`${this.baseUrl}/clients/invoices/encrypt`, requestData);
      
      if (!response.data.success || !response.data.data.encrypted_number) {
        throw new Error('Errore durante la criptazione del numero della fattura');
      }

      const pdfResponse = await this.http.get(`${this.baseUrl}/clients/invoices/${response.data.data.encrypted_number}/pdf`, {
        params: {
          data_emissione: formattedDate
        }
      });

      if (pdfResponse.data.success && pdfResponse.data.data.stream_url) {
        const pdfBlob = await this.http({
          url: pdfResponse.data.data.stream_url,
          method: 'GET',
          responseType: 'blob',
        });
        
        this.filemanager.open(pdfBlob, {type: 'application/pdf'});
      } else {
        throw new Error(pdfResponse.data.message || 'Errore durante il recupero del PDF');
      }
      
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadFattureZip(numeriFattura = [], filename = null){
    const url = `${this.baseUrl}/clienti/fatture/zip`
    try {
      const payload = {
        filters: {
          'fattura_vendita.numeri': numeriFattura
        }
      }

      if (filename) {
        payload.filename = filename
      }

      const res = await this.http.post(url, payload, { responseType: 'blob' })
      this.filemanager.download(res, {type: 'application/zip'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadFattureEsteseZip(numeriFattura = [], filename = null){
    const url = `${this.baseUrl}/clienti/fatture/dettagli/estesi/zip`
    try {
      const payload = {
        filters: {
          'fattura_vendita.numeri': numeriFattura
        }
      }

      if (filename) {
        payload.filename = filename
      }

      const res = await this.http.post(url, payload, { responseType: 'blob' })
      this.filemanager.download(res, {type: 'application/zip'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }


  async changeFatturaContestazione(obj){
    let item = {}

    const url = `${this.baseUrl}/clienti/fatture/contestazione/update`
    try {
      let res = await this.http.post(url,{obj})
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async setPdfError(numero, pdfError) {
    const url = `${this.baseUrl}/clienti/fatture/${encodeURIComponent(numero)}/pdf-error`
    const res = await this.http.post(url, { pdf_error: pdfError ? 1 : 0 })
    return res.data
  }

  async getInfoPostaNumero(numeroFattura) {
    let item = {}
    const url = `${this.baseUrl}/clients/invoices/info-posta-numero`
    try {
      const res = await this.http.post(url, {
        numero_fattura: numeroFattura
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getSaldoFattura(numero) {
    const url = `${this.baseUrl}/clients/invoices/${encodeURIComponent(numero)}/saldo`
    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async spostamentoCreditoFattura(payload) {
    const url = `${this.baseUrl}/clients/invoices/spostamento-credito`
    try {
      const res = await this.http.post(url, payload)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getRichiestaRimborso(numero) {
    const url = `${this.baseUrl}/clients/invoices/${encodeURIComponent(numero)}/richiesta-rimborso`
    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getRichiestaStorno(numero) {
    const url = `${this.baseUrl}/clients/invoices/${encodeURIComponent(numero)}/richiesta-storno`
    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async insertRichiesteStorno(numeri) {
    const url = `${this.baseUrl}/clients/invoices/richieste-storno`
    try {
      const res = await this.http.post(url, { numeri })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async insertRichiestaRimborso({ numero, importo, saldo_pre_rimborso, note = null }) {
    const url = `${this.baseUrl}/clients/invoices/richiesta-rimborso`

    try {
      const formData = new FormData()
      formData.append('numero', numero)
      formData.append('importo', importo)
      formData.append('saldo_pre_rimborso', saldo_pre_rimborso)

      if (note !== null && note !== undefined && String(note).trim() !== '') {
        formData.append('note', String(note).trim())
      }

      const res = await this.http.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async saveLogRichiestaRimborso({ numero, saldo, id = 0 }) {
    const url = `${this.baseUrl}/clients/invoices/richiesta-rimborso/log`

    try {
      const res = await this.http.post(url, {
        numero,
        saldo,
        id,
      })
      return res.data
    } catch (err) {
      console.error('Errore durante il salvataggio del log richiesta rimborso:', err)
    }
  }

  async deleteCompensazioneFattura({ id_payment = null, numero = null, cod_type_pay_mode, value = null, related_payment_ids = null } = {}) {
    const url = `${this.baseUrl}/clients/invoices/delete-compensazione`
    try {
      const payload = { cod_type_pay_mode }

      if (id_payment !== null && id_payment !== undefined && id_payment !== '') {
        payload.id_payment = Number(id_payment)
      } else {
        payload.numero = numero
        payload.value = value
      }

      if (Array.isArray(related_payment_ids) && related_payment_ids.length > 0) {
        payload.related_payment_ids = related_payment_ids.map((x) => Number(x))
      }

      const res = await this.http.post(url, payload)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
  async getNcFattureDocumentiCliente(content, idCliente) {
    const url = `${this.baseUrl}/clienti/note-credito-fatture/${content}/cliente/${idCliente}`
    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      return null
    }
  }

  async getNcFatturaDettaglio(content, numero, tipo) {
    const url = `${this.baseUrl}/clienti/note-credito-fatture/${content}/dettaglio`
    try {
      const res = await this.http.get(url, { params: { numero, tipo } })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      return null
    }
  }

  async getNcFatture(content, page = 1, perPage = 8, search = null){
    let items = []
    let pagination = {
      current_page: page,
      per_page: perPage,
      total: 0,
      last_page: 1,
    }

    const url = `${this.baseUrl}/clienti/note-credito-fatture/${content}`
    const params = { page, per_page: perPage }
    if (search && String(search).trim() !== '') {
      params.search = String(search).trim()
    }
    try {
      let res = await this.http.get(url, { params })
      items = res.data.data || []
      pagination = res.data.pagination || pagination
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        pagination,
      }
    }
  }

  getFatturaDettagliataPdf(numero) {
    const url = `${this.baseUrl}/clienti/fatture/${numero}/dettagli/pdf`
    return this.http({
      url,
      method: 'GET',
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `fattura_${numero}_dettagliata.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  getFatturaEstesaPdf(numero) {
    const url = `${this.baseUrl}/clienti/fatture/${numero}/dettagli/estesi/pdf`
    return this.http({
      url,
      method: 'GET',
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `fattura_${numero}_estesa.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  async findLogByEmail(email) {
    const url = `${this.baseUrl}/clienti/fatture/log-by-email`
    try {
      const res = await this.http.get(url, { params: { email } })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

}
